module.exports = __webpack_public_path__ + "img/link03_sp.eae453c5.png";